module.exports = __webpack_public_path__ + "static/footer-btn.c8a47436.png";